module.exports = "pegasus/assets/theme3/large/1.jpg";